











import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import {
  NavigationPane,
} from "../../../../../base/components/panes";
import {
  ModelEditableMixin,
} from "../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin, CommonComponentsAccessibleMixin } from "../mixins";
import { DomainRegistry } from "../../../../domain";
import { IFormatRegistrationResultRegisteredDetail, FormatStructureEditor, EditableFormatSummary } from "../../../../domain/editableFormat";
import { FormatTreeSource, ITreeSource } from "../../selectors/trees/sources";
import EditableFormatSummaryTreeNameEditDialog from "../../selectors/trees/dialogs/EditableFormatSummaryTreeNameEditDialog.vue";

@Component({
  components: {
    NavigationPane,
    NameEditDialog: EditableFormatSummaryTreeNameEditDialog,
  },
})
export default class FormatEditNavigationContainer extends Mixins(ModelEditableMixin, FormatStructureEditableMixin, CommonComponentsAccessibleMixin) {
  @Prop({ type: Function, default: () => {} })
  complementFormatStructure: () => void;

  @Emit()
  formatRegistered(id: number, destinationRoute: any, isTemporary: boolean, archiveId: number): any {}

  data() {
    return {
      isRegistering: false,
    };
  }
  isRegistering: boolean;
  treeSource: ITreeSource<number, EditableFormatSummary> = new FormatTreeSource();

  $refs!: {
    nameEditDialog: EditableFormatSummaryTreeNameEditDialog,
  };

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  async registerFormat(): Promise<void> {
    const isValidateOk = await this.getCommonComponents().getOperators().getValidator().validate(true);
    if (!isValidateOk) {
      this.$warn("登録中止", "登録する" + this.formatNameWording + "に問題があったため登録を中止します。警告内容を確認してください。");
      return;
    }
    try {
      await this.registerFormatStructure(false);
    } catch (e) {
      this.$error("登録失敗", this.formatNameWording + "の登録に失敗しました。", e);
    }
  }

  async registerFormatAsTemporary(): Promise<void> {
    try {
      await this.registerFormatStructure(true);
    } catch (e) {
      this.$error("登録失敗", this.formatNameWording + "の一時保存に失敗しました。", e);
    }
  }

  async registerFormatStructure(isTemporary: boolean): Promise<void> {
    try {
      const formatStructure = this.editingSource as FormatStructureEditor;
      const editableFormat = formatStructure.getSource();
      const isNew = (editableFormat.id == null);
      let selectedDirectoryId = null as number;

      if (isNew) {
        if (await this.hasFolder()) {
          selectedDirectoryId = await this.getCommonComponents().getDialogs().getTreeSelectDialog().show();
        } else if (await this.confirmToAddFirstFolder()) {
          selectedDirectoryId = await this.addFirstFolder();
        }
        if (!selectedDirectoryId) {
          console.debug("保存先フォルダ選択キャンセル");
          return;
        }
      }

      this.complementFormatStructure();

      this.$logger.info("登録を開始します。");
      this.isRegistering = true;
      const registry = DomainRegistry.instance;
      const result = await registry.editableFormat.getFormatRepository().registerFormatStructure(this.editingSource, isTemporary);

      if (result === undefined) {
        this.$logger.info("登録がキャンセルされました。");
        return null;
      }
      if (!result.isRegistered) {
        // TODO
      } else {
        const detail = result.detail as IFormatRegistrationResultRegisteredDetail;
        if (!detail.id) {
          this.$error(
            "登録失敗",
            this.formatNameWording + "を登録できませんでした。",
          );
          this.$logger.warn("登録ハンドラがnullを返却しています.実装を確認してください.");
          return null;
        }

        const name = editableFormat.name;
        if (isNew) {
          // TODO インデックスが固定になっているので問題あれば変更必要
          await this.updateFormatToDirectory(selectedDirectoryId, detail.id, name, 1);
        }

        this.$logger.info("登録完了イベントを発行します.");
        this.formatRegistered(detail.id, undefined, isTemporary, detail.archiveId);
      }
    } catch (e) {
      throw e;
    } finally {
      this.isRegistering = false;
    }
  }

  async hasFolder(): Promise<boolean> {
    if (!this.treeSource) { return false; }
    const folderTree = await this.treeSource.getTree();
    return !!folderTree && folderTree.length > 0;
  }

  async confirmToAddFirstFolder(): Promise<boolean> {
    const index = await this.$commonDialogs.confirmation.confirmCancel(
      "フォルダ確認",
      [this.formatNameWording + "の保存先となるフォルダが1つもない為登録できません。",
        "フォルダを追加して登録しますか？"],
      "フォルダを追加して登録する");
    return (index === 0);
  }

  async addFirstFolder(): Promise<number> {
    await this.$refs.nameEditDialog.show(true, true, "");
    if (!this.$refs.nameEditDialog.result) {
      return;
    }
    try {
      const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
      const id = await repository.addDirectory(this.$refs.nameEditDialog.modifiedText, null, 1);
      this.$success(
        "フォルダ追加完了",
        "フォルダを追加しました。",
      );
      return id;
    } catch (e) {
      this.$error(
        "フォルダ追加失敗",
        "フォルダの追加に失敗した為、" + this.formatNameWording + "の登録ができませんでした。",
        e);
      return null;
    }
  }

  async updateFormatToDirectory(parentId: number, formatid: number, name: string, index: number): Promise<void> {
    const registry = DomainRegistry.instance;
    await registry.editableFormat.getFormatRepository().addFormat(formatid, name, parentId, index);
  }
}
